import { render, staticRenderFns } from "./SelectListDialog.vue?vue&type=template&id=d628f8e0"
import script from "./SelectListDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectListDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports